import { createNewStore } from 'api/admin/stores/stores';

/**
 * Store state
 * @typedef {Object} StoreState
 * @property  {string|null} businessId
 * @property  {string} name
 * @property  {string} address
 * @property  {string} city
 * @property  {string|null} state
 * @property  {string} zipCode
 * @property  {string|null} districtId
 * @property  {string} phoneNumber
 * @property  {string} dcaRetail
 * @property  {string} dcaCommercial
 * @property  {string|null} taxRateId
 * @property  {string} password
 * @property  {string} confirmPassword
 */

/**
 * Form the request body for a new store
 * @param {StoreState} storeState
 * @returns {Object} Request body
 */
const formData = (storeState) => {
  const businessId = parseInt(storeState.businessId);
  const name = storeState.name.trim() || null;
  const address = storeState.address.trim() || null;
  const city = storeState.city.trim() || null;
  const state = storeState.state.trim() || null;
  const zipCode = storeState.zipCode.trim() || null;
  const districtId = parseInt(storeState.districtId);
  const phoneNumber = storeState.phoneNumber.trim() || null;
  const dcaRetail = storeState.dcaRetail.trim() || null;
  const dcaCommercial = storeState.dcaCommercial.trim() || null;
  const taxRateId = parseInt(storeState.taxRateId);
  const password = storeState.password.trim() || null;
  const confirmPassword = storeState.confirmPassword.trim() || null;

  return {
    businessId: Number.isNaN(businessId) ? null : businessId,
    name,
    address,
    city,
    state,
    zipCode,
    districtId: Number.isNaN(districtId) ? null : districtId,
    phoneNumber,
    dcaRetail,
    dcaCommercial,
    taxRateId: Number.isNaN(taxRateId) ? null : taxRateId,
    password,
    confirmPassword,
  };
};

/**
 * Create new store
 * @param {{ needsRegions: boolean, onSave: function } & StoreState} props
 */
async function createStore({ needsRegions, onSave, ...newStore }) {
  const data = formData(newStore);

  const body = {
    businessId: data.businessId,
    name: data.name,
    address: data.address,
    city: data.city,
    state: data.state,
    zipCode: data.zipCode,
    phoneNumber: data.phoneNumber,
    password: data.password,
    confirmPassword: data.confirmPassword,
    taxRateId: data.taxRateId,
    dcaLicense: data.dcaRetail,
    commercialDcaLicense: data.dcaCommercial,
  };

  if (needsRegions) {
    body.districtId = data.districtId;
  }

  const response = await createNewStore(body);

  const id = response.data.id;
  onSave(id);
}

export default createStore;
